var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9474 6.29024C14.3395 6.42396 14.5489 6.85017 14.4152 7.24221L11.0042 17.2422C10.8704 17.6343 10.4442 17.8437 10.0522 17.71C9.66016 17.5762 9.45076 17.15 9.58448 16.758L12.9955 6.75795C13.1292 6.36592 13.5554 6.15652 13.9474 6.29024ZM6.56434 7.02841C6.85552 7.323 6.85276 7.79787 6.55816 8.08905L2.85648 11.7479C2.71451 11.8882 2.71451 12.1121 2.85648 12.2524L6.55816 15.9112C6.85276 16.2023 6.85552 16.6772 6.56434 16.9718C6.27316 17.2664 5.7983 17.2692 5.5037 16.978L1.80202 13.3192C1.06599 12.5917 1.06599 11.4085 1.80202 10.681L5.5037 7.02222C5.7983 6.73104 6.27316 6.73381 6.56434 7.02841ZM17.4357 7.02841C17.7268 6.73381 18.2017 6.73104 18.4963 7.02222L22.198 10.681C22.934 11.4085 22.934 12.5917 22.198 13.3192L18.4963 16.978C18.2017 17.2692 17.7268 17.2664 17.4357 16.9718C17.1445 16.6772 17.1472 16.2023 17.4418 15.9112L21.1435 12.2524C21.2855 12.112 21.2855 11.8882 21.1435 11.7479L17.4418 8.08905C17.1472 7.79787 17.1445 7.323 17.4357 7.02841Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.d9a19575c46beae3b7c42c8288fcdf7e.svg";
export { ForwardRef as ReactComponent };